module.exports = __webpack_public_path__ + "static/img/WILL-LORENZ.cf5eeb8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/WILL-LORENZ.jpg
// module id = pbmP
// module chunks = 0